module.exports = __webpack_public_path__ + "img/IMG_2493-2-2.29f088f1.jpg";